<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Mail Grubu Oluştur</h4>
              <p class="card-category">Aşağıdaki form ile bir mail grubu oluşturun, tek seferde birden fazla kişiye gönderin.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Kod Ismi" placeholder="Daha sonra aradığınızda kolay bulmanız için..." v-model="payload.title">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <base-checkbox v-model="payload.isActive">
                    Aktif
                  </base-checkbox>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <base-checkbox v-model="payload.isSpecialGroup">
                    Özel Grup Mu?
                  </base-checkbox>
                </div>
                <label>Özel olan gruba ait mailler, başka bir özel gruba aktif olarak eklenemez. </label>
              </div>

              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewFromMail">
                  Oluştur
                </button>
              </div>
              <div class="clearfix"></div>
            </form>


          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import CollectionService from "../../services/collection.service.js";

  export default {
    components: {
      Card
    },
    data() {
      return {
        payload: {},
      }
    },
    mounted() {
    },
    methods: {
      createNewFromMail() {
        CollectionService.postWidthAuth('mailgroup', this.payload).then((res) => {
          if (res.success == true) {
            this.$router.push(`/admin/mailgroups`);
            this.notifyVue('bottom', 'right', 'success', "Mail Grubu Oluşturuldu")
          } else {
            console.log('error');
            this.notifyVue('bottom', 'right', 'danger', res.body)
          }
        }).catch(err=>{
            this.notifyVue('bottom', 'right', 'danger', err)
        })
      },
      notifyVue (verticalAlign, horizontalAlign,type, message) {
        this.$notifications.notify(
          {
            message:  JSON.stringify(message),
            icon: '',
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type
          })
      }
    }
  }
</script>
<style>
</style>